import { createContext } from 'react';

/**
 * True when a public page is being shown inside the signed-in shell (its menu is beside it).
 *
 * The public site chrome — the marketing top bar with Log in and Register — is right for a visitor and
 * wrong for a customer who already has the menu. Pages that wear the marketing shell read this to drop
 * their top bar and sign-in actions while keeping their content and footer.
 */
export const InAppShellContext = createContext<boolean>(false);

export default InAppShellContext;
